// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Internal Dependencies:
import PageSectionEditorUI from 'church-theme-library/components/PageSections/_PageSectionEditorUI'
import PasswordProtected from 'church-theme-library/components/PageSections/_PasswordProtected'
import PostContent from 'church-theme-library/components/PageSections/PostContent'
import EventDetails from 'church-theme-library/components/PageSections/EventDetails'
import BulletinDetails from 'church-theme-library/components/PageSections/BulletinDetails'
import ResourceExternalVideo from 'church-theme-library/components/PageSections/ResourceExternalVideo'

import Hero from 'church-theme-library/components/PageSections/Hero'
import Quote from 'church-theme-library/components/PageSections/Quote'
import CallToActionHeadingLink from 'church-theme-library/components/PageSections/CallToActionHeadingLink'
import CallToActionHeadingTextLink from 'church-theme-library/components/PageSections/CallToActionHeadingTextLink'
import FeatureBlocks from 'church-theme-library/components/PageSections/FeatureBlocks'
import Pullquote from 'church-theme-library/components/PageSections/Pullquote'
import PullquoteImage from 'church-theme-library/components/PageSections/PullquoteImage'
// import TextImageColumns from 'church-theme-library/components/PageSections/TextImageColumns'
import EmailNewsletterSignup from 'church-theme-library/components/PageSections/EmailNewsletterSignup'
import Contact from 'church-theme-library/components/PageSections/Contact'
import SocialLinks from 'church-theme-library/components/PageSections/SocialLinks'
import ThisWeek from 'church-theme-library/components/PageSections/ThisWeek'
import SabbathSchool from 'church-theme-library/components/PageSections/SabbathSchool'
// import ThisWeekAndMap from 'church-theme-library/components/PageSections/ThisWeekAndMap'
import LocationAndMap from 'church-theme-library/components/PageSections/LocationAndMap'
import MapSection from 'church-theme-library/components/PageSections/MapSection'
import Pastors from 'church-theme-library/components/PageSections/Pastors'
import OurChurch from 'church-theme-library/components/PageSections/OurChurch'
import Livestream from 'church-theme-library/components/PageSections/Livestream'
import PrayerRequest from 'church-theme-library/components/PageSections/PrayerRequest'

import LatestNewsAndEvents from 'church-theme-library/components/PageSections/LatestNewsAndEvents'
import LatestNews from 'church-theme-library/components/PageSections/LatestNews'
import LatestEvents from 'church-theme-library/components/PageSections/LatestEvents'
import LatestVideos from 'church-theme-library/components/PageSections/LatestVideos'
import LatestBulletin from 'church-theme-library/components/PageSections/LatestBulletin'
import ResourceCategory from 'church-theme-library/components/PageSections/ResourceCategory'

import FacebookEmbed from 'church-theme-library/components/PageSections/FacebookEmbed'
import FacebookFeedApi from 'church-theme-library/components/PageSections/FacebookFeedApi'
import InstagramFeedApi from 'church-theme-library/components/PageSections/InstagramFeedApi'

import FreeOffer from 'church-theme-library/components/PageSections/FreeOffer'
import Columns from 'church-theme-library/components/PageSections/Columns'
import Heading from 'church-theme-library/components/PageSections/Heading'
import Columns2TextMedia from 'church-theme-library/components/PageSections/Columns2TextMedia'
import Columns2HeadingText from 'church-theme-library/components/PageSections/Columns2HeadingText'
import Columns2TextFancyImages from 'church-theme-library/components/PageSections/Columns2TextFancyImages'
import ImageLinks from 'church-theme-library/components/PageSections/ImageLinks'
import MediaSection from 'church-theme-library/components/PageSections/MediaSection'

import AdvertisementFaithFM from 'church-theme-library/components/PageSections/AdvertisementFaithFM'
import AdvertisementMumsAtTheTable from 'church-theme-library/components/PageSections/AdvertisementMumsAtTheTable'
import AdvertisementHopeChannelNz from 'church-theme-library/components/PageSections/AdvertisementHopeChannelNz'
import AdvertisementAdventistRadioLondon from 'church-theme-library/components/PageSections/AdvertisementAdventistRadioLondon'
import AdvertisementAwr from 'church-theme-library/components/PageSections/AdvertisementAwr'

import Resources from 'church-theme-library/components/PageSections/Resources'
import Attachments from 'church-theme-library/components/PageSections/Attachments'
import Posts from 'church-theme-library/components/PageSections/Posts'

import LoadingSpinner from 'church-theme-library/components/LoadingSpinner/LoadingSpinner'

import { get } from 'church-theme-library/utilities/objects'

class PageSections extends React.Component {
	renderContent = () => {
		const { archiveCategoriesById, sabbathSchoolDataReceived, videosReceived, livestreamReceived, facebookFeedReceived, instagramFeedReceived, userCanEditPage } = this.props
		const page = this.props.pageOverride ? this.props.pageOverride : this.props.page

		if ( ! page ) {
			return null
		}

		let evenOdd = 'even',
			previousEvenOdd = 'even',
			previousType = '',
			allRequiredDataReceived = true

		const itemsMarkup = page.page_sections && Object.keys( page.page_sections ).length ? Object.keys( page.page_sections ).map( ( key, index ) => {
			let item = page.page_sections[ key ]
			let component = null
			let className = `page-section page-section-${item.type}`
			let combineWithPrevious = get( ['settings', 'combine_with_previous'] )( item, false )

			if ( combineWithPrevious ) {
				className += ' is-combined-with-previous'
			}

			// Switch even/odd:
			previousEvenOdd = evenOdd

			if ( ! combineWithPrevious ) {
				evenOdd = 'even' == evenOdd ? 'odd' : 'even'
			}

			// Check for cases when even/odd should not swtich:
			if (
				'columns_2_heading_text' == previousType && 'columns_2_heading_text' == item.type ||
				'columns_2_text_media' == previousType && 'columns_2_text_media' == item.type
			) {
				evenOdd = previousEvenOdd
			}

			className += ` is-${evenOdd}`

			previousType = item.type

			switch ( item.type ) {
				case 'post_content':
					component = <PostContent contentId="page_sections" sectionId={ key } data={ item } />
					break

				case 'event_details':
					component = <EventDetails contentId="page_sections" sectionId={ key } data={ item } />
					break

				case 'bulletin_details':
					component = <BulletinDetails contentId="page_sections" sectionId={ key } data={ item } />
					break

				case 'resource_external_video':
					component = <ResourceExternalVideo contentId="page_sections" sectionId={ key } data={ item } />
					break

				case 'hero':
					component = <Hero contentId="page_sections" sectionId={ key } data={ item } />
					break

				case 'quote':
					component = <Quote contentId="page_sections" sectionId={ key } data={ item } />
					break

				case 'call_to_action_heading_link':
					component = <CallToActionHeadingLink contentId="page_sections" sectionId={ key } data={ item } />
					break

				// case 'call_to_action_heading_text_link':
				// 	component = <CallToActionHeadingTextLink contentId="page_sections" sectionId={ key } data={ item } />
				// 	break

				// case 'feature_blocks':
				// 	component = <FeatureBlocks contentId="page_sections" sectionId={ key } data={ item } />
				// 	break

				case 'pullquote':
					component = <Pullquote contentId="page_sections" sectionId={ key } data={ item } />
					break

				case 'pullquote_image':
					component = <PullquoteImage contentId="page_sections" sectionId={ key } data={ item } />
					break

				case 'email_newsletter_signup':
					component = <EmailNewsletterSignup contentId="page_sections" sectionId={ key } data={ item } />
					break

				case 'contact':
					component = <Contact contentId="page_sections" sectionId={ key } data={ item } />
					break

				case 'social_links':
					component = <SocialLinks contentId="page_sections" sectionId={ key } data={ item } />
					break

				case 'this_week':
					component = <ThisWeek contentId="page_sections" sectionId={ key } data={ item } />

					if ( ! sabbathSchoolDataReceived ) {
						allRequiredDataReceived = false
					}

					break

				// case 'sabbath_school':
				// 	component = <SabbathSchool contentId="page_sections" sectionId={ key } data={ item } />
				// 	break

				// case 'this_week_and_map':
				// 	component = <ThisWeekAndMap contentId="page_sections" sectionId={ key } data={ item } />
				// 	break

				case 'location_and_map':
					component = <LocationAndMap contentId="page_sections" sectionId={ key } data={ item } />
					break

				case 'map':
					component = <MapSection contentId="page_sections" sectionId={ key } data={ item } />
					break

				// case 'pastors':
				// 	component = <Pastors contentId="page_sections" sectionId={ key } data={ item } />
				// 	break

				// case 'our_church':
				// 	component = <OurChurch contentId="page_sections" sectionId={ key } data={ item } />
				// 	break

				case 'livestream':
					component = <Livestream contentId="page_sections" sectionId={ key } data={ item } />

					if ( ! livestreamReceived ) {
						allRequiredDataReceived = false
					}

					break

				case 'prayer_request':
					component = <PrayerRequest contentId="page_sections" sectionId={ key } data={ item } />
					break

				case 'latest_news_and_events':
					component = <LatestNewsAndEvents contentId="page_sections" sectionId={ key } data={ item } />

					if ( ! ! archiveCategoriesById.id_posts_latest || ! archiveCategoriesById.id_events_latest ) {
						allRequiredDataReceived = false
					}

					break

				case 'latest_news':
					component = <LatestNews contentId="page_sections" sectionId={ key } data={ item } />

					if ( ! archiveCategoriesById.id_posts_latest ) {
						allRequiredDataReceived = false
					}

					break

				case 'latest_events':
					component = <LatestEvents contentId="page_sections" sectionId={ key } data={ item } />

					if ( ! archiveCategoriesById.id_events_latest ) {
						allRequiredDataReceived = false
					}

					break

				case 'latest_videos':
					component = <LatestVideos contentId="page_sections" sectionId={ key } data={ item } />

					if ( ! videosReceived ) {
						allRequiredDataReceived = false
					}

					break

				case 'latest_bulletin':
					component = <LatestBulletin contentId="page_sections" sectionId={ key } data={ item } />

					if ( ! archiveCategoriesById.id_bulletins_latest ) {
						allRequiredDataReceived = false
					}

					break

				case 'resource_category':
					component = <ResourceCategory contentId="page_sections" sectionId={ key } data={ item } />

					let categorySlug = get( ['settings', 'category_slug'] )( item, {} )
					if ( ! userCanEditPage && ! archiveCategoriesById[ `id_resources_${categorySlug}` ] ) {
						allRequiredDataReceived = false
					}

					break

				case 'facebook_embed':
					component = <FacebookEmbed contentId="page_sections" sectionId={ key } data={ item } />
					break

				case 'facebook_feed_api':
					component = <FacebookFeedApi contentId="page_sections" sectionId={ key } data={ item } />

					if ( ! facebookFeedReceived ) {
						allRequiredDataReceived = false
					}

					break

				case 'instagram_feed_api':
					component = <InstagramFeedApi contentId="page_sections" sectionId={ key } data={ item } />

					if ( ! instagramFeedReceived ) {
						allRequiredDataReceived = false
					}

					break

				// case 'free_offer':
				// 	component = <FreeOffer contentId="page_sections" sectionId={ key } data={ item } />
				// 	break

				case 'heading':
					component = <Heading contentId="page_sections" sectionId={ key } data={ item } />
					break

				case 'columns':
					component = <Columns contentId="page_sections" sectionId={ key } data={ item } />
					break

				case 'columns_2_text_media':
					component = <Columns2TextMedia contentId="page_sections" sectionId={ key } data={ item } />
					break

				case 'columns_2_heading_text':
					component = <Columns2HeadingText contentId="page_sections" sectionId={ key } data={ item } />
					break

				case 'columns_2_text_fancy_images':
					component = <Columns2TextFancyImages contentId="page_sections" sectionId={ key } data={ item } />
					break

				case 'image_links':
					component = <ImageLinks contentId="page_sections" sectionId={ key } data={ item } />
					break

				case 'media':
					component = <MediaSection contentId="page_sections" sectionId={ key } data={ item } />
					break

				case 'ad_faith_fm':
					component = <AdvertisementFaithFM contentId="page_sections" sectionId={ key } data={ item } />
					break

				case 'ad_mums_at_the_table':
					component = <AdvertisementMumsAtTheTable contentId="page_sections" sectionId={ key } data={ item } />
					break

				case 'ad_hope_channel_nz':
					component = <AdvertisementHopeChannelNz contentId="page_sections" sectionId={ key } data={ item } />
					break

				case 'ad_adventist_radio_london':
					component = <AdvertisementAdventistRadioLondon contentId="page_sections" sectionId={ key } data={ item } />
					break

				case 'ad_awr':
					component = <AdvertisementAwr contentId="page_sections" sectionId={ key } data={ item } />
					break
			}

			return (
				<section className={ className } key={ key }>
					{ component }

					<PageSectionEditorUI id="page_sections" sectionId={ key } sectionData={ item } prevItemKey={ key } allSections={ page.page_sections } />
				</section>
			)
		} ) : null

		let className = 'page-sections is-editable-page-sections'

		if ( ! allRequiredDataReceived ) {
			className += ' is-loading'
		}

		return (
			<div className={ className }>
				{ ! allRequiredDataReceived &&
					<LoadingSpinner />
				}

				<PageSectionEditorUI id="page_sections" isFirst={ true } />

				{ itemsMarkup }

				{ ! itemsMarkup &&
					<section className="page-section">
						<div className="page-section-empty"></div>
					</section>
				}

				{/*<Resources { ...this.props } />
				<Attachments { ...this.props } />
				<Posts { ...this.props } />*/}
			</div>
		)
	}

	renderPasswordProtected = () => {

	}

	render() {
		const page = this.props.pageOverride ? this.props.pageOverride : this.props.page

		if ( ! page ) {
			return null
		}

		if ( page.is_password_protected ) {
			return (
				<div className="page-sections">
					<section className="page-section page-section-post_content is-odd">
						<PasswordProtected />
					</section>
				</div>
			)
		} else {
			return this.renderContent()
		}
	}
}

const mapStateToProps = ( state, ownProps ) => {
	let userCanEditPage = siteData.current_user_can_edit_pages

	if ( state.page.selected && state.page.selected.is_external ) {
		userCanEditPage = false
	}

	return {
		sabbathSchoolDataReceived: state.site.sabbathSchoolDataReceived,
		videosReceived: state.site.videosReceived,
		livestreamReceived: state.site.livestreamReceived,
		page: state.page.selected,
		archiveCategoriesById: state.page.archiveCategoriesById,
		facebookFeedReceived: state.page.facebookFeedReceived,
		instagramFeedReceived: state.page.instagramFeedReceived,
		userCanEditPage
	}
}

export default connect( mapStateToProps )( PageSections )
